// src/pages/ContactPage.jsx

import React from "react";
import { Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const ContactPage = () => {
  return (
    <div className="pt-20 px-4 py-12 bg-gray-50">
      <div className="max-w-4xl mx-auto space-y-10">
        {/* Heading */}
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Get in Touch</h1>
          <p className="text-gray-600 text-lg">
            We'd love to hear from you! Reach out via email, phone, or visit our location.
          </p>
        </div>

        {/* Contact Info */}
        <div className="space-y-6 text-center text-gray-700 text-lg">
          {/* Email */}
          <div>
            <strong>Email (General Enquiries):</strong>{" "}
            <a
              href="mailto:info@emric.co.in"
              className="text-blue-600 hover:text-blue-700 transition-colors duration-200"
            >
              info@emric.co.in
            </a>
          </div>

          {/* Phone & WhatsApp */}
          <div>
            <strong>Phone (Orders):</strong>{" "}
            <a
              href="tel:+918383002598"
              className="text-blue-600 hover:text-blue-700 transition-colors duration-200"
            >
              +91 83830 02598
            </a>

            <div className="mt-3 flex justify-center gap-6">
              <a
                href="tel:+918383002598"
                className="text-gray-700 hover:text-blue-700 transition-colors duration-200"
              >
                <Phone className="w-6 h-6" />
              </a>
              <a
                href="https://wa.me/918383002598"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-[#25D366] transition-colors duration-200"
              >
                <FaWhatsapp className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Address */}
          <div>
            <strong>Address:</strong><br />
            Aarsh Industries,<br />
            Insta Industrial Park,<br />
            Bavla, Ahmedabad,<br />
            Gujarat, India
          </div>
        </div>

        {/* Google Map */}
        <div className="rounded overflow-hidden shadow-lg">
          <iframe
            title="Aarsh Industries Location"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d58851.320407201514!2d72.3429522!3d22.794773!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e95dc7a5e9525%3A0xb5f124ba7ddfa386!2sInsta%20Industrial%20Park!5e0!3m2!1sen!2sin!4v1751520290518!5m2!1sen!2sin"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
